import { http } from '../../config/axios'

export default function gerarNotaFiscalFatura(id:string) :Promise<Blob>{
    return http.get('/api/fatura/gerar-nota-fiscal/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao gerarNotaFiscalFatura')
        return new Blob()
    })
}
